import { createContext, useContext, useMemo, useState } from 'react'

// The wizard's accumulated signup data, merged from the mutation responses at
// each step. facebookPixel and endPage render off it as siblings of the form,
// so it cannot live in the form's own state.
const initialUser = {
  acceptPrivacyPolicy: false,
  acceptTracking: false,
  city: '',
  email: '',
  firstName: '',
  lastName: '',
  membership: false,
  personalNumber: '',
  birthYear: '',
  phone: '',
  street: '',
  zip: '',
}

export const SignupContext = createContext()

export const useSignup = () => useContext(SignupContext)

export const SignupProvider = ({ children }) => {
  const [user, setUser] = useState(initialUser)
  const [index, setIndex] = useState(0)

  const value = useMemo(() => {
    const mergeUser = (data) => setUser((prev) => ({ ...prev, ...data }))
    const nextPage = () => setIndex((prev) => prev + 1)
    return { user, mergeUser, index, nextPage }
  }, [user, index])

  return (
    <SignupContext.Provider value={value}>{children}</SignupContext.Provider>
  )
}
